<div
    class="relative flex flex-row items-center justify-between p-[12px] w-full bg-yellow-100 rounded-none bp908:rounded-2xl cursor-pointer shadow-p-form-field-shadow overflow-hidden"
    (click)="checklistClick()">
    <img
        class="z-0 absolute translate-y-0 left-[-7px] size-[65px] object-cover"
        src="/assets/images/hand_waving_emoji.png" />

    <div class="z-[1] w-full text-left text-primary font-semibold text-[12px] leading-5"
        >WELCOME CHECKLIST</div
    >

    <div class="z-[1] flex flex-row items-center justify-center gap-[20px]">
        <fm-new-welcome-checklist-progress-indicator
            class="text-[13px]"
            [steps]="steps"
            [activeStep]="activeStep"></fm-new-welcome-checklist-progress-indicator>
        <fa-icon class="hidden text-[20px] text-primary" [icon]="faCircleChevronDown"></fa-icon>
    </div>
</div>
